export const IS_AUTH_FROM_CHECKOUT = "IS_AUTH_FROM_CHECKOUT";
export const CHECKOUT_ID = "CHECKOUT_ID";
